export var RefType;
(function (RefType) {
    RefType["IFrame"] = "iframe";
    RefType["Blackbox"] = "blackbox";
    RefType["Transaction"] = "transaction";
})(RefType || (RefType = {}));
